import React from 'react'
import './TimeSlots.css'
import { useState, useEffect } from 'react';

const TrainingTimeSlots = ({ ShowTimeSlots, setShowTimeSlots, setEnrollmentData, EnrollmentData, setClassHoursData, classHoursData, Err, setErr, setShowSchedule, isClassHours, timeSlots }) => {
    console.log("timeslots in the timeslot components are:", timeSlots)

    const days = [...new Set(timeSlots?.map(slot => slot.DayOfWeek))];

    const uniqueTimeRanges = [
    ...new Set(
        timeSlots?.map(slot => `${slot.StartTime} - ${slot.EndTime}`)
    )
    ];

    const OnSelectSchedule = () => {
        setShowTimeSlots(false);
        setShowSchedule(true);
    };

    return (
        ShowTimeSlots
            ? <div
                className='flex flex-col fixed justify-center  items-center top-0 z-20 h-[calc(100vh_-_80px)] min-h-fit bg-[#00000040] w-full mt-20'
            >
                <div className='bg-white rounded-[40px] gap-6 flex flex-col justify-center items-center w-[95%] xl:w-fit mx-5 overflow-hidden px-2 md:px-14 py-14 '
                >
                    <div 
                    // className='flex w-full h-fit overflow-x-scroll overflow-y-auto py-2 xl:justify-center'
                        className="flex w-full max-h-[60vh] overflow-x-auto overflow-y-auto py-2 xl:justify-center"
                        id='TimeSlotScrollbar'
                    >
                        <div className='flex overflow-x-auto flex-col w-fit '>

                            <table 
                            className="min-w-[800px] border-collapse text-xs shadow-md"
                            // className="border-collapse text-xs shadow-md"
                            >
                                <thead>
                                <tr>
                                    <th className="text-6xs md:text-5xs lg:text-4xs xl:text-3xs text-[#A1A3EF] text-center w-56 Blackfont border-l-0 border-t-0 border-[#E6E6E6] border-solid border-[2px] border-l-0 border-t-0"></th>
                                    {days?.map(day => (
                                    <th key={day} className="text-6xs md:text-5xs lg:text-4xs xl:text-3xs text-center w-52 py-2 
                                    Blackfont border-l-0 border-t-0 border-[#E6E6E6] border-solid border-[2px] border-l-0 border-t-0">
                                        {day}
                                    </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {uniqueTimeRanges?.map(timeRange => (
                                    <tr key={timeRange}>
                                    <td className="border-l-0 border-t-0 border-[#E6E6E6] border-solid border-[2px] border-l-0 border-t-0 bg-gray-50 py-5">
                                        {timeRange}
                                    </td>
                                    {days?.map(day => {
                                        const isChecked = EnrollmentData.StudentData.Schedule[day]?.includes(timeRange);

                                        return (
                                        <td key={day + timeRange} 
                                        className="text-[18px] py-5 Blackfont text-center border-l-0 border-t-0 border-[#E6E6E6] border-solid border-[2px] border-l-0 border-t-0 bg-gray-50">
                                            <input
                                            type="checkbox"
                                            className='w-[17px] h-[17px]'
                                            checked={isChecked}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                const updatedSchedule = { ...EnrollmentData.StudentData.Schedule };

                                                if (checked) {
                                                updatedSchedule[day] = [...(updatedSchedule[day] || []), timeRange];
                                                } else {
                                                updatedSchedule[day] = (updatedSchedule[day] || []).filter(tr => tr !== timeRange);
                                                }

                                                setEnrollmentData(prev => ({
                                                ...prev,
                                                StudentData: {
                                                    ...prev.StudentData,
                                                    Schedule: updatedSchedule
                                                }
                                                }));
                                            }}
                                            />
                                        </td>
                                        );
                                    })}
                                    </tr>
                                ))}
                                </tbody>
                            </table>

                        </div>
                    </div>


                    <button type='button' onClick={OnSelectSchedule} className='text-base text-white bg-[#A1A3EF] px-[18px] py-[9px]   rounded-xl cursor-pointer w-fit'>
                        Select Schedule
                    </button>
                </div>
            </div>
            : null
    )
}

export default TrainingTimeSlots